<script>
export default {
    name: 'AppFooter',
};
</script>

<template>
<div id="footer">
    <div class="wrapper">
        <div class="left">
            <img class="logo" src="@/assets/logo-footer.png" alt="Logo Starface">
        </div>
        <div class="right">
            <div class="mail">
                <img src="@/assets/starface_icons_png/24/grey/mail.png" alt="Mail Logo">
                <a href="mailto:up@starface.com">up@starface.com</a>
            </div>
            <div class="phone">
                <img src="@/assets/starface_icons_png/24/grey/numbers_24.png" alt="Phone Logo">
                <a href="tel:+4972198199100">+ 49 721 981 991 00</a>
            </div>
            <div class="faq">
                <img src="@/assets/starface_icons_svg/faq.svg" alt="FAQ Logo">
                <a href="https://knowledge.starface.de/display/starup/" target="_blank">FAQ</a>
            </div>
        </div>
    </div>

</div>
</template>

<style lang="scss" scoped>
@import "../assets/scss/variables.scss";

#footer {
    min-height: 72px;
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: #676767;
    color: $grey-bright;
    z-index: 5;
    .wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        max-width: 1024px;
        margin: auto;
        padding: 24px;
        .left {
            display: flex;
            align-items: center;
            .logo {
            height: 24px;
            }
            .title {
                color: $grey-light;
            }
        }
        .right {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            letter-spacing: 0;
            line-height: 22px;
            .mail {
                display: flex;
                align-items: center;
                padding-right: 32px;

                img {
                    height: 17px;
                }
            }
            .phone {
                display: flex;
                align-items: center;
                padding-right: 32px;

                img {
                    height: 24px;
                }
            }
            .faq {
                display: flex;
                align-items: center;
                
                img {
                    height: 24px;
                }
            }
        }
        img {
            padding-right: 8px;
        }
    }
}
</style>
